import { GET_DB_DATA_TYPES_SUCCESS, LOGOUT_COMPLETE } from '../../constants/actionTypes';

const initialState = {};

export const dbDataTypesReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_DB_DATA_TYPES_SUCCESS:
      return saveDBDataTypes(state, action);

    case LOGOUT_COMPLETE:
      return initialState;

    default:
      return state;
  }
};

export default dbDataTypesReducer;

function saveDBDataTypes(state, action) {
  const {
    connectionType,
    receivedAt,
    data: { dbTypes: dbDataTypes, schemaToDbTypes: schemaToDBDataTypes },
  } = action;

  return {
    ...state,
    [connectionType]: {
      dbDataTypes,
      schemaToDBDataTypes,
      lastUpdated: receivedAt,
    },
  };
}
